import {
  Box,
  Text,
  VStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from '@chakra-ui/react';
import { useBinderCardColors } from '../hooks/useBinderCardColors';

interface DataTableCardProps {
  description?: string;
  headers: string[];
  rows: (string | React.ReactNode)[][];
}

const DataTableCard = ({ description, headers, rows }: DataTableCardProps) => {
  const colors = useBinderCardColors();

  return (
    <Box>
      {/* Header */}
      {description && (
        <VStack align="start" spacing={3} mb={3}>
          <Text
            color={colors.textColor}
            lineHeight="1.5"
            fontSize="sm"
            fontWeight={'semibold'}
          >
            {description}
          </Text>
        </VStack>
      )}

      {/* Data Table */}
      <Box
        borderRadius="md"
        borderWidth="1px"
        borderColor={colors.borderColor}
        overflow="hidden"
      >
        <Table size="sm">
          <Thead bg={colors.tableHeaderBg}>
            <Tr>
              {headers.map((header, index) => (
                <Th
                  key={index}
                  color={colors.labelColor}
                  fontSize="xs"
                  fontWeight="semibold"
                >
                  {header}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {rows.length === 0 ? (
              <Tr>
                <Td colSpan={headers.length} textAlign="center" py={6}>
                  <Text color="gray.500" fontSize="sm" fontStyle="italic">
                    No data available
                  </Text>
                </Td>
              </Tr>
            ) : (
              rows.map((row, rowIndex) => (
                <Tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <Td key={cellIndex}>
                      {typeof cell === 'string' ? (
                        <Text
                          fontSize="sm"
                          fontWeight={cellIndex === 0 ? 'medium' : 'normal'}
                        >
                          {cell}
                        </Text>
                      ) : (
                        cell
                      )}
                    </Td>
                  ))}
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default DataTableCard;
